import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from "react-router-dom";
import { AUTH_CHALLENGES } from "@/constants/auth";
import { useAuth } from "@/context/auth/AuthContext";
import { usePortalNavigationAccess } from "@/hooks/usePortalNavigationAccess";
import { LOGIN_PAGE } from "./paths";
/**
 * Route guard for MFA challenge page.
 * Only allows access if there's an active MFA challenge.
 */ export default function MfaChallengeRoute({ children }) {
    const { challengeData, isAuthenticated, initialized } = useAuth();
    const { defaultPage, isLoading: isNavigationAccessLoading } = usePortalNavigationAccess(isAuthenticated);
    // Wait for auth to initialize before making redirect decisions
    if (!initialized || isAuthenticated && isNavigationAccessLoading) {
        return null;
    }
    // If already authenticated, redirect to the product-appropriate landing page.
    if (isAuthenticated) {
        return /*#__PURE__*/ _jsx(Navigate, {
            to: defaultPage,
            replace: true
        });
    }
    // If no MFA challenge data, redirect to login
    if (!challengeData || challengeData.challengeName !== AUTH_CHALLENGES.SOFTWARE_TOKEN_MFA && challengeData.challengeName !== AUTH_CHALLENGES.SMS_MFA) {
        return /*#__PURE__*/ _jsx(Navigate, {
            to: LOGIN_PAGE,
            replace: true
        });
    }
    // Valid MFA challenge session, render the page
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
}
